import { useAppStore } from "../store/useAppStore";
import { Download, RefreshCw } from "lucide-react";

export function MockupGallery() {
  const { mockups } = useAppStore();

  const completedMockups = mockups.filter((m) => m.status === "COMPLETED" && m.mockupUrl);

  if (!completedMockups.length) {
    return (
      <div className="text-center py-12 text-gray-500">
        <RefreshCw className="h-8 w-8 mx-auto mb-3 text-gray-300" />
        <p>還沒有生成的 Mockup</p>
        <p className="text-sm mt-1">選擇產品並點擊「生成 Mockup」</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h3 className="font-semibold">生成的 Mockup</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {completedMockups.map((mockup) => (
          <div
            key={mockup.id}
            className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden group"
          >
            <div className="aspect-square bg-gray-100 relative">
              <img
                src={mockup.mockupUrl!}
                alt="Mockup"
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </div>
            <div className="p-3 flex items-center justify-between">
              <div className="text-xs text-gray-500">
                {mockup.status}
              </div>
              <a
                href={mockup.mockupUrl!}
                download
                className="p-2 rounded-lg hover:bg-gray-100 text-gray-600 transition-colors"
                title="下載"
              >
                <Download className="h-4 w-4" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
